import React from 'react';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { CircularProgress, Stack, SxProps, styled } from '@mui/material';

import palette from '../theme/palette';

const Container = styled(Stack)(
  ({ loading, disabled }: { loading: number; disabled: boolean }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    width: '40px',
    borderRadius: '50%',
    padding: '12px',
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    opacity: disabled || loading ? 0.4 : 1,
    backgroundColor: palette.white,
    border: `1px solid ${palette.grey[100]}`,
    ':hover': {
      opacity: 0.8
    },
    ...(!disabled &&
      !loading && {
        '&:active': {
          opacity: 0.6
        }
      })
  })
);

const BackButton = ({
  onClick,
  sx,
  disabled = false,
  loading = false
}: {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  sx?: SxProps;
  disabled?: boolean;
  loading?: boolean;
}) => (
  <Container sx={sx} loading={+loading} disabled={disabled} onClick={onClick}>
    {!loading ? (
      <ArrowBackOutlinedIcon sx={{ fontSize: '16px' }} />
    ) : (
      <CircularProgress sx={{ color: palette.blue[100], width: '16px' }} size="20px" />
    )}
  </Container>
);

export default BackButton;
